import { SvgIcon, type SvgIconProps } from "@mui/material";

export const DocumentIcon = (props: SvgIconProps) => (
	<SvgIcon {...props}>
		<path d="M6 22.5C5.45 22.5 4.97917 22.3042 4.5875 21.9125C4.19583 21.5208 4 21.05 4 20.5V4.5C4 3.95 4.19583 3.47917 4.5875 3.0875C4.97917 2.69583 5.45 2.5 6 2.5H14L20 8.5V20.5C20 21.05 19.8042 21.5208 19.4125 21.9125C19.0208 22.3042 18.55 22.5 18 22.5H6ZM13 9.5V4.5H6V20.5H18V9.5H13Z" />
	</SvgIcon>
);
